import React, {Fragment, useEffect, useRef, useState} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import { Cards } from 'src/components/PurchaseCart/fragments/Card';

import { Avatar, Grid, IconButton, TextField} from '@material-ui/core'; 
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp'; 
import {isEmpty} from "lodash"; 
import {useDispatch, useSelector} from "react-redux";
import NewQtyForMonth from '../../../Inventory/NewQtyForMonth';
import {Stack, Typography, Chip} from "@mui/material";
import useToggle from "../../../../shared/functions/useToggle";
import AntDataGrid from "../../../../shared/components/AntDataGrid";
import NewQtyToBuy from "./NewQtyToBuy";
import {purchaseCartList, setCartId, updateRef} from "../../../../redux/slices/purchaseCartList";


import Button from '@material-ui/core/Button';
import {firestore} from "../../../../config/firebaseConfig";

import { useHistory } from "react-router-dom";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import Icon, { AppstoreOutlined, MenuOutlined } from '@ant-design/icons';
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import {cartOrderCollection, itemsCollection} from "../../../../constant/firestore";
import DeletePopover from "../../../_customs/DeletePopover";
import {toast} from "react-toastify";
import DeletePrompt from "../../../categories/fragments/DeletePrompt";
let myItemId = ''
let myNewQtyToBuy = 0
const batch = firestore.batch();

function DisplayCard(props){
   const CartId = useSelector((state) => state.purchaseCartListRef.cartId);
//    const CartName = useSelector((state) => state.purchaseCartListRef.cartName);
   console.log("vendor id:",CartId)

    const Data = useSelector((state) => state.purchaseCartListRef.ref[CartId]);
    console.log(Data)
    const handleActionClick = () => {
        alert('Action button clicked!');
        // Add your custom action logic here
      };
      const handleEllipsisClick = () => {
        alert('Ellipsis button clicked!');
        // Add your custom ellipsis action logic here
      };
    return(
        <div className='row'>
            {Data?.map((title) => {
return (
  <Cards
    lb={title.Badge}
    id={title.id}
    lastprice={title.LastBuyPrice}
    formouth={title.QuatityForMonth}
    title={title.Name}
    imageurl={title.ImageUrl}
    body={title.UPC}
    QuantityInPO={title.QuantityInPO}
    QuantityInShpping={title.QuantityInShpping}
    QuantityCasa={title.Stores.Cassablanca.Quantity}
    QuantityDekon={title.Stores.Dekon.Quantity}
    QuantityToBuy={title.QuantityToBuy}
    RestQtyToBuy={title.RestQtyToBuy}
    OrderInfos={title.OrderInfo? title.OrderInfo : null}
    vendorid={CartId}
    vendorname={title.Vendors ? title.Vendors: null}
    onActionClick={handleActionClick}
    onEllipsisClick={handleEllipsisClick}

  />
);
})}
        </div>
    )
}

export default function PurchaseCartDetailList({ CartI}) {
//#region STATE
const [listcard,setListCard]= useState('card');
const handleTableShowing = (etat) =>{
    if(etat=='card'){
        setListCard('card');
    }
    else{
        setListCard('list');
    }
}


    const dispatch = useDispatch();

    dispatch(setCartId(CartI))
    const [loading, setLoading] = React.useState(false), [filters, setFilter] = React.useState({
            name: '',
            bcode: '',
            prosoft: '',
            expdate: ''
        }), [v2ApiHasBeenCalled, setv2ApiHasBeenCalled] = useState(false), [list, setList] = useState([]), [isLoading, setIsLoading] = useState(false), [initData, setInitData] = useState([]), [selected, setSelected] = useState(),
        CartId = useSelector((state) => state.purchaseCartListRef.cartId),
        Data = useSelector((state) => state.purchaseCartListRef.ref[CartId]), [deleteTogle, setDeleteTogle] = useState(false),
        ref = useRef(),
        reternProduct = async (id) => {
            try {
                const subCollectionName = CartId;
                const documentName = id;

                const batch = firestore.batch(); // Créez un nouveau batch à chaque appel de la fonction

                // Supprimer le document dans la sous-collection
                const deleteCardItemRef = cartOrderCollection
                    .doc(subCollectionName)
                    .collection('cart_items')
                    .doc(documentName);
                batch.delete(deleteCardItemRef);

                // Mettre à jour le champ IsInCart dans le document itemsCollection
                const refItem = itemsCollection.doc(id);
                batch.update(refItem, {IsInCart: false});

                await batch.commit(); // Exécutez l'opération d'écriture par lots

                setv2ApiHasBeenCalled(!v2ApiHasBeenCalled);

                toast.success('Supprimé avec succès');

                setLoading(false);
            } catch (error) {
                console.error('Erreur lors de la suppression du produit:', error);
                toast.error('Une erreur s\'est produite lors de la suppression du produit.');
                setLoading(false);
            }

        },
        columns = [
            {
                title: 'Image', dataIndex: 'ImageUrl', key: 'ProductImageUrl',
                render: (image) => {
                    return (
                        <>
                            {
                                image
                                    ? <Avatar alt={'...'} src={image}/>
                                    : <Avatar>no</Avatar>
                            }
                        </>
                    )
                }
            },

            {
                title: 'Name', dataIndex: 'Name', key: 'Name',
                render: (val, {IsParent, HasChilds}) => {

                    const ft = text => (text || '')?.trim()?.toLowerCase()

                    const list = ['pack', ' pac ', ' pak ', ' pk '];

                    let flag = ((IsParent || [])?.length > 0) || (HasChilds) || false

                    list.forEach(label => {
                        if (ft(val)?.includes(label))
                            flag = true
                    })

                    return (
                        <Stack direction={'row'} spacing={1}>
                            <Typography>
                                {val}
                            </Typography>

                            {flag && (<Chip color={'success'} label={'Pk'}/>)}

                        </Stack>
                    )
                }
            },
            {
                title: 'Qt. to purchase', dataIndex: '_', key: 'Stock',
                
                render: (_, record) => (
                    <NewQtyToBuy {...record} callback={async (ItemId, CartId, QuantityToBuy,QuantityInPO,QuantityInShpping) => {

                        myItemId = ItemId
                        myNewQtyToBuy = QuantityToBuy

                        const docSnap = await firestore.collection(`/cart_order/${CartId}/cart_items`).get();
                        const newData = docSnap.docs.map(doc => doc.data());
                        dispatch(updateRef({CartId: CartId, newData: newData}))

                        setv2ApiHasBeenCalled(!v2ApiHasBeenCalled)

                    }}/>
                )
            },
            {
                title: 'Qt. left to buy', dataIndex: '_', key: 'Stock',
                render: (_, {RestQtyToBuy}) => RestQtyToBuy
            },
            {
                title: 'Action', dataIndex: 'ItemId', key: 'ItemId',
                render: (ItemId) => {

                    const handleDeleteClick = (e) => {
                        setSelected(e)
                        setDeleteTogle(true);
                    };

                    const handleConfirmationClose = () => {
                        setDeleteTogle(false);
                    };

                    const handleDeleteConfirm = () => {

                        // Appel de la fonction de suppression ici
                        reternProduct(selected); // Remplacez `deleteItem` par le nom de votre fonction de suppression

                        setDeleteTogle(false);
                    };

                    return (
                        <>
                           <div style={{ cursor: "pointer" }} 
                           //onClick={e => handleAddClick(ItemId)}
                           >
                                <AddCircleIcon color={'success'}/>
                            </div>
                            <div style={{ cursor: "pointer" }} onClick={e => handleDeleteClick(ItemId)}>
                                <DeleteOutlineIcon color={'error'}/>
                            </div>
                            {deleteTogle && (
                                <DeletePrompt
                                    open={deleteTogle}
                                    onClose={handleConfirmationClose}
                                    onConfirm={handleDeleteConfirm}
                                />
                            )}
                        </>
                    );
                }
            }

        ];


    let history = useHistory();


    useEffect(()=>{


            setIsLoading(true)
            dispatch( purchaseCartList({

                docId: CartId, onResolve:  (data) => {
                    let newData = []
                   data.forEach(element => {
                        let v = {...element, CartId: CartId};
                        newData.push(v)

                    });
                    dispatch(updateRef({CartId:CartId,newData:newData}))
                    setInitData(newData)



                }
            })).then(()=>
             setIsLoading(false))

            setv2ApiHasBeenCalled(true)
        }, [v2ApiHasBeenCalled])
        

        


 

//#endregion

//#region FILTER
    const handleFilterChange = (e) => {
        setFilter({[e.target.name]: e.target.value});
    }

   /* useEffect(() => {
        return () => {
            setData(DataInit)
        };
    }, [DataInit]);
*/

    React.useEffect(() => {
         let toFilter =initData || []
        let searchFilter = []

        if (!isEmpty(filters.name)) {
            let resName = []
            toFilter.forEach((item) => {
                const my_data = item

                if (my_data.Name?.trim().toString().toUpperCase().includes(filters.name?.toUpperCase())) {
                    resName.push(item)
                    searchFilter = resName;

                }

            })
        }

        if (!isEmpty(filters.bcode)) {
            const resBarCode = []
            toFilter.forEach((item) => {
                const bareCode = item

                if (bareCode.UPC?.trim().toUpperCase().includes(filters.bcode?.toUpperCase())) {
                    resBarCode.push(item)
                    searchFilter = resBarCode;
                }

            })
        }

        if (!isEmpty(filters.prosoft)) {
            const resId = []
            toFilter.forEach((item) => {
                const my_id = item
                if (my_id.InternalId?.trim().toString().toUpperCase().includes(filters.prosoft?.toUpperCase())) {
                    resId.push(item)
                    searchFilter = resId;
                }
            })
        }

        const isFilterEmpty = isEmpty(filters.name) && isEmpty(filters.bcode) && isEmpty(filters.prosoft);

        if (!isFilterEmpty){
            /*setData(searchFilter)*/

            dispatch(updateRef({CartId:CartId,newData:searchFilter}))

        }else {
            dispatch(updateRef({CartId:CartId,newData:initData}))

        }



    }, [filters,loading])





    const handlsetValidCart = () => {

        firestore.collection('vendors').doc(CartId)
            .update({
            'Validation': 'yes'
        }).then(()=>{
            history.goBack()

        })



    }

    const handlePageChange = (current, total) => (current === (total - 1) || current === total) && isLoading

    return (
        <> 
        <Grid container spacing={2} style={{padding: 20}}>
            <Grid item> <TextField margin="dense" variant="outlined" name="name" value={filters.name}
                                    onChange={handleFilterChange} label="chercher par nom"/> </Grid>
            <Grid item> <TextField margin="dense" variant="outlined" name="bcode" value={filters.bcode}
                                    onChange={handleFilterChange} label="chercher par code barre"/> </Grid>
            <Grid item> <TextField margin="dense" variant="outlined" name="prosoft" value={filters.prosoft}
                                    onChange={handleFilterChange} label="chercher par Prosoft id"/> </Grid>

            <Grid item>
                                    {listcard=='card'?
                                    <IconButton edge="start" onClick={()=>handleTableShowing('list')} aria-label="close">
                                     <MenuOutlined/>
                                       SHOW LIST
                                    </IconButton>:
                                     <IconButton edge="start" onClick={()=>handleTableShowing('card')} aria-label="close">
                                     <AppstoreOutlined/>
                                       SHOW CARD
                                    </IconButton>} 
            </Grid>
        </Grid>
        {
            listcard == 'card' ? <DisplayCard /> :
        <AntDataGrid
                data={Data}
                columns={columns}
                isLoading={isLoading}
                ToolBar={null}
                onPageChange={handlePageChange}
                shadows
            />}



            {
                /*
                selected && (
                    <InventoryDetails
                        open={open}
                        item={selected}
                        onClose={handleDetailModalClosing}
                    />
                )*/
            }
        </>
    )
//#endregion

}

